import {checkIfBotHasBonusDice} from "./checkIfBotHasBonusDice";
import {checkIfAnyOpponentIsBot} from "./checkIfAnyOpponentIsBot";
import {getPlayerBonusValues} from "../gameState/getPlayerBonusValues";

// Пол броска d6 бота: бросок равновероятен в диапазоне [пол, 6]. Задает его
// уровень бонуса (поле d6MinRoll в configs/playerBonus) — сейчас только у
// «божества», и там пол 6: d6 всегда 6, кость урона всегда 0. У остальных
// уровней поля нет — пол 1, честная кость.
//
// Действует только у бота, помеченного ботом для всех (см.
// checkIfBotHasBonusDice): явного бота рейтингового матча — по числам,
// зафиксированным в его bonusConfig при формировании лобби, и бота локальной
// партии — по текущему конфигу его уровня. Выпавшие кости кладутся в сами
// действия, поэтому записи матчей от правки чисел не расходятся.
//
// Подкрутка общая для всех бросков d6 бота: кости урона в ближнем бою (и в
// атаке, и в защите), при стрельбе и перебросах, разведка рудника гномов.
// Кроме боя с ботами (opponents, см. checkIfAnyOpponentIsBot): кость урона
// «всегда 0» у божественного бота — только против живых игроков и нейтральных
// отрядов, против любого бота он бросает обычные кости. В бою к полу добавляется +1 против игрока под
// давлением ботов (см. getBotCombatD6MinRoll).
export const getBotD6MinRoll = (player, opponents) => (
  checkIfBotHasBonusDice(player) && !checkIfAnyOpponentIsBot(player, opponents)
    ? getPlayerBonusValues(player).d6MinRoll || 1
    : 1
);
